import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import { AppBar } from '@/components/AppBar';
import { Sidebar } from '@/components/Sidebar';
import { BrandingFooter } from '@/components/BrandingFooter';
import { useUIStore } from '@/store/uiStore';
import { useSessionExpiry } from '@/hooks/useSessionExpiry';

const DRAWER_WIDTH = 240;

export function PrivateLayout() {
  const sidebarOpen = useUIStore((state) => state.sidebarOpen);
  const timetableStatusMessage = useUIStore((state) => state.timetableStatusMessage);
  const timetableStatusTimestamp = useUIStore((state) => state.timetableStatusTimestamp);

  // Redirect to /login when the API layer fires SESSION_EXPIRED_EVENT
  useSessionExpiry();

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <AppBar drawerWidth={DRAWER_WIDTH} />
      <Sidebar drawerWidth={DRAWER_WIDTH} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: { xs: 0, sm: sidebarOpen ? `${DRAWER_WIDTH}px` : 0 },
          height: '100vh',
          width: { xs: '100%', sm: sidebarOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%' },
          bgcolor: 'background.default',
          transition: 'margin-left 0.3s ease, width 0.3s ease',
          overflow: 'hidden',
        }}
      >
        <Toolbar />
        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
        <BrandingFooter 
          statusMessage={timetableStatusMessage}
          statusTimestamp={timetableStatusTimestamp}
        />
      </Box>
    </Box>
  );
}
